import { render, staticRenderFns } from "./submenu.vue?vue&type=template&id=485353ab&scoped=true"
import script from "./submenu.vue?vue&type=script&lang=js"
export * from "./submenu.vue?vue&type=script&lang=js"
import style0 from "./submenu.vue?vue&type=style&index=0&id=485353ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485353ab",
  null
  
)

export default component.exports